export default "__VITE_ASSET__64fa630e__"